/* ════════════════════════════════════════════════════════
   NAPOON GALLERY v22.6
   FOUC: inline style on every element + CSS !important for switching.
   Speed: visibility-based slides (pre-decoded) + input capture phase.
   + Badge prévente/stock dynamique au changement de variante.
   ════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  console.log('[NapoonGallery] v22.6 loaded');

  /* Desktop product page: header is ALWAYS visible (sticky via CSS in header.liquid). */
  var stickyHeader = document.querySelector('sticky-header');
  if (stickyHeader && document.querySelector('.product__media-wrapper')) {
    var desktopMQ = window.matchMedia('(min-width: 990px)');
    var headerSection = document.querySelector('.section-header');
    var _origHide = stickyHeader.hide;
    var _origReveal = stickyHeader.reveal;
    var _origReset = stickyHeader.reset;

    stickyHeader.hide = function() {
      if (desktopMQ.matches) {
        if (headerSection) headerSection.classList.remove('shopify-section-header-hidden');
        return;
      }
      _origHide.call(this);
    };

    stickyHeader.reveal = function() {
      if (desktopMQ.matches) {
        if (headerSection) headerSection.classList.remove('shopify-section-header-hidden');
        return;
      }
      _origReveal.call(this);
    };

    stickyHeader.reset = function() {
      if (desktopMQ.matches) {
        if (headerSection) headerSection.classList.remove('shopify-section-header-hidden');
        return;
      }
      _origReset.call(this);
    };
  }

  var DESKTOP_BP = 990;
  var TH_GAP = 8;
  var MAX_TH = 5;
  var MAX_M = 4;

  var galleries = new Map();

  /* ── Helpers ── */

  function getActiveSlideCount(galleryEl) {
    var group = galleryEl.querySelector('#napoonSlidesContainer .napoon-slide-group.active');
    return group ? group.querySelectorAll('.napoon-slide').length : 0;
  }

  function getLb() {
    return document.querySelector('#napoonLb');
  }

  /* ════════════════════════════════════════════════════════
     INIT
     ════════════════════════════════════════════════════════ */

  function initGallery(galleryEl) {
    if (galleries.has(galleryEl)) return;

    console.log('[NapoonGallery] v22.6 init, version attr:', galleryEl.dataset.version);

    /* ── Unwrap <template> tags into live DOM (desktop + mobile thumbs) ── */
    galleryEl.querySelectorAll('template[data-napoon-th-tpl], template[data-napoon-thm-tpl]').forEach(function(tmpl) {
      var parent = tmpl.parentNode;
      var frag = document.importNode(tmpl.content, true);
      parent.insertBefore(frag, tmpl);
      parent.removeChild(tmpl);
    });

    var state = {
      galleryEl: galleryEl,
      cur: 0,
      thOff: 0,
      thMOff: 0,
      TH: 110,
      TH_M: 80,
      THUMB_H: 110,
      variantMap: {},
      activeGroup: null,
      currentVariantId: galleryEl.dataset.initialVariant || '',
      isDesktop: window.innerWidth >= DESKTOP_BP
    };

    /* Parse variant-to-group mapping */
    var mapEl = galleryEl.querySelector('[data-napoon-variant-map]');
    if (mapEl) {
      try { state.variantMap = JSON.parse(mapEl.textContent); }
      catch(e) { console.error('[NapoonGallery] Map parse error:', e); }
    }

    /* Parse map précommande (variant.id → true/false) + textes badge */
    state.preorderMap = {};
    var pmEl = galleryEl.querySelector('[data-napoon-preorder-map]');
    if (pmEl) {
      try { state.preorderMap = JSON.parse(pmEl.textContent); }
      catch(e) { console.error('[NapoonGallery] Preorder map parse error:', e); }
    }
    var bw = galleryEl.querySelector('#napoonBadgeWrap');
    state.badgeTexts = {
      preorder: {
        main: bw ? (bw.getAttribute('data-main-preorder') || '') : '',
        sub:  bw ? (bw.getAttribute('data-sub-preorder')  || '') : ''
      },
      stock: {
        main: bw ? (bw.getAttribute('data-main-stock') || '') : '',
        sub:  bw ? (bw.getAttribute('data-sub-stock')  || '') : ''
      }
    };

    /* Read initial active group from DOM */
    var activeGroup = galleryEl.querySelector('#napoonSlidesContainer .napoon-slide-group.active');
    state.activeGroup = activeGroup ? activeGroup.dataset.variantGroup : 'default';

    galleries.set(galleryEl, state);

    setupThumbClicks(galleryEl);
    rebuildDots(galleryEl);
    setupEventListeners(galleryEl);

    requestAnimationFrame(function() {
      syncThSize(galleryEl);
      syncThMSize(galleryEl);
      var col = galleryEl.querySelector('.napoon-thumbs-col');
      var mob = galleryEl.querySelector('.napoon-th-mobile-section');
      if (col) col.classList.add('napoon-ready');
      if (mob) mob.classList.add('napoon-ready');
      setupThMScrollListener(galleryEl);
    });
  }

  /* ── Thumbnail Click Listeners ── */

  function setupThumbClicks(galleryEl) {
    galleryEl.querySelectorAll('.napoon-th-group .napoon-thumb').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        goTo(galleryEl, parseInt(thumb.dataset.i, 10));
      });
    });
    galleryEl.querySelectorAll('.napoon-th-m-group .napoon-th-m-item').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        goTo(galleryEl, parseInt(thumb.dataset.i, 10));
      });
    });
  }

  /* ════════════════════════════════════════════════════════
     GROUP SWITCHING — targeted (only touches old + new group)
     ════════════════════════════════════════════════════════ */

  function switchGroup(galleryEl, groupId) {
    var state = galleries.get(galleryEl);
    if (state.activeGroup === groupId) return;

    var oldId = state.activeGroup;
    state.activeGroup = groupId;
    state.cur = 0;
    state.thOff = 0;
    state.thMOff = 0;

    var oldSel = '[data-variant-group="' + oldId + '"]';
    var newSel = '[data-variant-group="' + groupId + '"]';

    galleryEl.querySelectorAll(oldSel).forEach(function(g) { g.classList.remove('active'); });
    galleryEl.querySelectorAll(newSel).forEach(function(g) { g.classList.add('active'); });

    var lb = getLb();
    if (lb) {
      lb.querySelectorAll(oldSel).forEach(function(g) { g.classList.remove('active'); });
      lb.querySelectorAll(newSel).forEach(function(g) { g.classList.add('active'); });
    }

    resetFirstActive(galleryEl, '#napoonSlidesContainer', '.napoon-slide');
    if (lb) resetFirstActive(lb, '#napoonLbSlidesContainer', '.napoon-lb-slide');

    var thGroup = galleryEl.querySelector('.napoon-th-group.active');
    if (thGroup) {
      thGroup.querySelectorAll('.napoon-thumb').forEach(function(t, i) {
        t.classList.toggle('active', i === 0);
      });
    }
    var thMGroup = galleryEl.querySelector('.napoon-th-m-group.active');
    if (thMGroup) {
      thMGroup.querySelectorAll('.napoon-th-m-item').forEach(function(t, i) {
        t.classList.toggle('active', i === 0);
      });
    }

    rebuildDots(galleryEl);
    applyThOff(galleryEl);
    applyThMOff(galleryEl);
    refreshThBtns(galleryEl);
    refreshThMBtns(galleryEl);

    requestAnimationFrame(function() {
      syncThSize(galleryEl);
      syncThMSize(galleryEl);
    });
  }

  function resetFirstActive(container, containerSel, slideSel) {
    var group = container.querySelector(containerSel + ' .napoon-slide-group.active');
    if (group) {
      group.querySelectorAll(slideSel).forEach(function(s, i) {
        s.classList.toggle('active', i === 0);
      });
    }
  }

  /* ════════════════════════════════════════════════════════
     NAVIGATION
     ════════════════════════════════════════════════════════ */

  function goTo(galleryEl, idx) {
    var state = galleries.get(galleryEl);
    var mainGroup = galleryEl.querySelector('#napoonSlidesContainer .napoon-slide-group.active');
    if (!mainGroup) return;
    var slides = mainGroup.querySelectorAll('.napoon-slide');
    if (!slides.length) return;

    var n = ((idx % slides.length) + slides.length) % slides.length;
    slides.forEach(function(s, i) { s.classList.toggle('active', i === n); });
    state.cur = n;

    if (n < state.thOff) state.thOff = n;
    else if (n >= state.thOff + MAX_TH) state.thOff = Math.max(0, n - MAX_TH + 1);
    applyThOff(galleryEl);

    var thGroup = galleryEl.querySelector('.napoon-th-group.active');
    if (thGroup) {
      thGroup.querySelectorAll('.napoon-thumb').forEach(function(t) {
        t.classList.toggle('active', parseInt(t.dataset.i, 10) === n);
      });
    }
    refreshThBtns(galleryEl);

    var thMGroup = galleryEl.querySelector('.napoon-th-m-group.active');
    if (thMGroup) {
      thMGroup.querySelectorAll('.napoon-th-m-item').forEach(function(t) {
        t.classList.toggle('active', parseInt(t.dataset.i, 10) === n);
      });
    }

    syncDots(galleryEl, '#napoonDotsBar .napoon-dot', n);

    var lb = getLb();
    if (lb) {
      var lbGroup = lb.querySelector('#napoonLbSlidesContainer .napoon-slide-group.active');
      if (lbGroup) {
        lbGroup.querySelectorAll('.napoon-lb-slide').forEach(function(s, i) {
          s.classList.toggle('active', i === n);
        });
      }
      syncDots(lb, '#napoonLbDotsBar .napoon-lb-dot', n);
      syncDots(lb, '#napoonLbDotsM .napoon-lb-dot', n);
    }
  }

  /* ════════════════════════════════════════════════════════
     DOTS
     ════════════════════════════════════════════════════════ */

  function rebuildDots(galleryEl) {
    var state = galleries.get(galleryEl);
    var count = getActiveSlideCount(galleryEl);
    buildDots(galleryEl, 'napoonDotsBar', count, state.cur, 'napoon-dot', false);
    var lb = getLb() || galleryEl;
    buildDots(lb, 'napoonLbDotsBar', count, state.cur, 'napoon-lb-dot', true);
    buildDots(lb, 'napoonLbDotsM', count, state.cur, 'napoon-lb-dot', true);
  }

  function buildDots(container, containerId, count, active, className, isLb) {
    var el = container.querySelector('#' + containerId);
    if (!el) return;
    var html = '';
    for (var i = 0; i < count; i++) {
      html += '<button class="' + className + (i === active ? ' active' : '') + '" data-i="' + i + '"></button>';
    }
    el.innerHTML = html;
    el.querySelectorAll('button').forEach(function(btn, idx) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var gEl = container.closest('.napoon-gallery') || document.querySelector('.napoon-gallery');
        if (!gEl) return;
        if (isLb) lbGoTo(gEl, idx); else goTo(gEl, idx);
      });
    });
  }

  function syncDots(container, selector, idx) {
    container.querySelectorAll(selector).forEach(function(el, i) {
      el.classList.toggle('active', i === idx);
    });
  }

  /* ════════════════════════════════════════════════════════
     THUMBNAIL SCROLL
     ════════════════════════════════════════════════════════ */

  function applyThOff(galleryEl) {
    var state = galleries.get(galleryEl);
    var thList = galleryEl.querySelector('#napoonThList');
    if (!thList) return;
    thList.style.transform = 'translateY(-' + (state.thOff * (state.THUMB_H + TH_GAP)) + 'px)';
  }

  function refreshThBtns(galleryEl) {
    var state = galleries.get(galleryEl);
    var count = getActiveSlideCount(galleryEl);
    var btnUp = galleryEl.querySelector('#napoonThUp');
    var btnDown = galleryEl.querySelector('#napoonThDown');
    if (!btnUp || !btnDown) return;
    btnUp.classList.toggle('hidden', state.thOff <= 0);
    btnDown.classList.toggle('hidden', count <= MAX_TH || state.thOff >= count - MAX_TH);
  }

  function applyThMOff(galleryEl) {
    var state = galleries.get(galleryEl);
    var thMobile = galleryEl.querySelector('#napoonThMobile');
    if (!thMobile) return;
    thMobile.style.transform = 'translateX(-' + (state.thMOff * (state.TH_M + TH_GAP)) + 'px)';
  }

  function refreshThMBtns(galleryEl) {
    var state = galleries.get(galleryEl);
    var thMGroup = galleryEl.querySelector('.napoon-th-m-group.active');
    var count = thMGroup ? thMGroup.querySelectorAll('.napoon-th-m-item').length : 0;
    var btnL = galleryEl.querySelector('#napoonThML');
    var btnR = galleryEl.querySelector('#napoonThMR');
    if (!btnL || !btnR) return;
    var hasMore = count > MAX_M;
    btnL.style.display = (hasMore && state.thMOff > 0) ? 'flex' : 'none';
    btnR.style.display = (hasMore && state.thMOff < count - MAX_M) ? 'flex' : 'none';
  }

  /* ════════════════════════════════════════════════════════
     SYNC THUMBNAIL SIZES
     ════════════════════════════════════════════════════════ */

  function syncThSize(galleryEl) {
    if (window.innerWidth <= 989) return;
    var state = galleries.get(galleryEl);
    var col = galleryEl.querySelector('.napoon-thumbs-col');
    if (!col) return;
    var W = galleryEl.offsetWidth;
    state.TH = Math.max(50, Math.min(160, Math.floor((W - 42) / 6)));
    col.style.width = state.TH + 'px';
    var imageH = W - state.TH - 10;
    col.style.height = imageH + 'px';
    state.THUMB_H = Math.floor((imageH - (MAX_TH - 1) * TH_GAP) / MAX_TH);
    galleryEl.querySelectorAll('#napoonThList .napoon-thumb').forEach(function(t) {
      t.style.height = state.THUMB_H + 'px';
    });
    applyThOff(galleryEl);
    refreshThBtns(galleryEl);
  }

  function syncThMSize(galleryEl) {
    if (window.innerWidth > 989) return;
    var state = galleries.get(galleryEl);
    var mainBox = galleryEl.querySelector('#napoonMainBox');
    if (!mainBox) return;
    var availW = mainBox.offsetWidth;
    if (!availW) return;
    state.TH_M = Math.floor((availW - (MAX_M - 1) * TH_GAP) / MAX_M);
    galleryEl.querySelectorAll('#napoonThMobile .napoon-th-m-item').forEach(function(t) {
      t.style.width = state.TH_M + 'px';
      t.style.height = state.TH_M + 'px';
    });
    var clip = galleryEl.querySelector('.napoon-th-mobile-clip');
    var outer = galleryEl.querySelector('.napoon-th-mobile-outer');
    if (clip) clip.style.width = availW + 'px';
    if (outer) outer.style.width = availW + 'px';
  }

  /* ── Mobile thumbnail arrow visibility based on scroll position ── */
  function setupThMScrollListener(galleryEl) {
    var clip = galleryEl.querySelector('.napoon-th-mobile-clip');
    var btnL = galleryEl.querySelector('#napoonThML');
    var btnR = galleryEl.querySelector('#napoonThMR');
    if (!clip || !btnL || !btnR) return;

    function updateThMArrows() {
      var atStart = clip.scrollLeft <= 2;
      var atEnd = clip.scrollLeft + clip.clientWidth >= clip.scrollWidth - 2;
      btnL.style.display = atStart ? 'none' : 'flex';
      btnR.style.display = atEnd ? 'none' : 'flex';
    }

    clip.addEventListener('scroll', updateThMArrows, { passive: true });
    updateThMArrows();
  }

  /* ════════════════════════════════════════════════════════
     LIGHTBOX
     ════════════════════════════════════════════════════════ */

  function lbGoTo(galleryEl, idx) {
    var lb = getLb();
    if (!lb) return;
    var lbGroup = lb.querySelector('#napoonLbSlidesContainer .napoon-slide-group.active');
    if (!lbGroup) return;
    var lbSlides = lbGroup.querySelectorAll('.napoon-lb-slide');
    if (!lbSlides.length) return;
    var n = ((idx % lbSlides.length) + lbSlides.length) % lbSlides.length;
    lbSlides.forEach(function(s, i) { s.classList.toggle('active', i === n); });
    syncDots(lb, '#napoonLbDotsBar .napoon-lb-dot', n);
    syncDots(lb, '#napoonLbDotsM .napoon-lb-dot', n);
    goTo(galleryEl, n);
  }

  function openLb(galleryEl) {
    var state = galleries.get(galleryEl);
    var lb = galleryEl.querySelector('#napoonLb') || getLb();
    if (!lb) return;
    lbGoTo(galleryEl, state.cur);
    if (lb.parentElement !== document.body) document.body.appendChild(lb);
    lb.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeLb(galleryEl) {
    var lb = getLb();
    if (!lb) return;
    lb.classList.remove('open');
    document.body.style.overflow = '';
    if (lb.parentElement === document.body && galleryEl) galleryEl.appendChild(lb);
  }

  /* ════════════════════════════════════════════════════════
     EVENT LISTENERS
     ════════════════════════════════════════════════════════ */

  function setupEventListeners(galleryEl) {
    var state = galleries.get(galleryEl);

    var prevBtn = galleryEl.querySelector('#napoonPrev');
    var nextBtn = galleryEl.querySelector('#napoonNext');
    if (prevBtn) prevBtn.addEventListener('click', function(e) { e.stopPropagation(); goTo(galleryEl, state.cur - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(e) { e.stopPropagation(); goTo(galleryEl, state.cur + 1); });

    var zoomBtn = galleryEl.querySelector('#napoonZoomBtn');
    if (zoomBtn) zoomBtn.addEventListener('click', function(e) { e.stopPropagation(); openLb(galleryEl); });

    var mainBox = galleryEl.querySelector('#napoonMainBox');
    if (mainBox) mainBox.addEventListener('click', function() { openLb(galleryEl); });

    var lbClose = galleryEl.querySelector('#napoonLbClose');
    var lbPrev = galleryEl.querySelector('#napoonLbPrev');
    var lbNext = galleryEl.querySelector('#napoonLbNext');
    var lbPrevM = galleryEl.querySelector('#napoonLbPrevM');
    var lbNextM = galleryEl.querySelector('#napoonLbNextM');
    var lb = galleryEl.querySelector('#napoonLb');

    if (lbClose) lbClose.addEventListener('click', function(e) { e.stopPropagation(); closeLb(galleryEl); });
    if (lbPrev) lbPrev.addEventListener('click', function() { lbGoTo(galleryEl, state.cur - 1); });
    if (lbNext) lbNext.addEventListener('click', function() { lbGoTo(galleryEl, state.cur + 1); });
    if (lbPrevM) lbPrevM.addEventListener('click', function() { lbGoTo(galleryEl, state.cur - 1); });
    if (lbNextM) lbNextM.addEventListener('click', function() { lbGoTo(galleryEl, state.cur + 1); });
    if (lb) lb.addEventListener('click', function(e) { if (e.target === lb) closeLb(galleryEl); });

    document.addEventListener('keydown', function(e) {
      var lbEl = getLb();
      if (!lbEl || !lbEl.classList.contains('open')) return;
      if (e.key === 'Escape') closeLb(galleryEl);
      else if (e.key === 'ArrowLeft') lbGoTo(galleryEl, state.cur - 1);
      else if (e.key === 'ArrowRight') lbGoTo(galleryEl, state.cur + 1);
    });

    var btnUp = galleryEl.querySelector('#napoonThUp');
    var btnDown = galleryEl.querySelector('#napoonThDown');
    if (btnUp) btnUp.addEventListener('click', function() {
      if (state.thOff > 0) { state.thOff--; applyThOff(galleryEl); refreshThBtns(galleryEl); }
    });
    if (btnDown) btnDown.addEventListener('click', function() {
      var maxOff = getActiveSlideCount(galleryEl) - MAX_TH;
      if (state.thOff < maxOff) { state.thOff++; applyThOff(galleryEl); refreshThBtns(galleryEl); }
    });

    var btnL = galleryEl.querySelector('#napoonThML');
    var btnR = galleryEl.querySelector('#napoonThMR');
    var thMClip = galleryEl.querySelector('.napoon-th-mobile-clip');
    if (btnL) btnL.addEventListener('click', function() {
      if (thMClip) thMClip.scrollBy({ left: -(state.TH_M + TH_GAP), behavior: 'smooth' });
    });
    if (btnR) btnR.addEventListener('click', function() {
      if (thMClip) thMClip.scrollBy({ left: state.TH_M + TH_GAP, behavior: 'smooth' });
    });
  }

  /* ════════════════════════════════════════════════════════
     SWIPE
     ════════════════════════════════════════════════════════ */

  function setupSwipe(galleryEl) {
    var state = galleries.get(galleryEl);
    var touchStart = 0;

    var mainBox = galleryEl.querySelector('#napoonMainBox');
    if (mainBox) {
      mainBox.addEventListener('touchstart', function(e) { touchStart = e.touches[0].clientX; }, { passive: true });
      mainBox.addEventListener('touchend', function(e) {
        var diff = e.changedTouches[0].clientX - touchStart;
        if (Math.abs(diff) > 40) goTo(galleryEl, state.cur + (diff < 0 ? 1 : -1));
      }, { passive: true });
    }

    var lbImages = galleryEl.querySelector('.napoon-lb-images');
    if (lbImages) {
      lbImages.addEventListener('touchstart', function(e) { touchStart = e.touches[0].clientX; }, { passive: true });
      lbImages.addEventListener('touchend', function(e) {
        var diff = e.changedTouches[0].clientX - touchStart;
        if (Math.abs(diff) > 40) lbGoTo(galleryEl, state.cur + (diff < 0 ? 1 : -1));
      }, { passive: true });
    }
  }

  /* ════════════════════════════════════════════════════════
     BADGE PRÉVENTE / STOCK
     ════════════════════════════════════════════════════════ */

  /* Met à jour le texte du badge selon l'état (prévente / stock) de la variante */
  function updateBadge(galleryEl, variantId) {
    var state = galleries.get(galleryEl);
    if (!state || !state.badgeTexts) return;

    var bw = galleryEl.querySelector('#napoonBadgeWrap');
    if (!bw) return;
    var badge = bw.querySelector('.napoon-badge');

    var isPreorder = state.preorderMap[String(variantId)] === true;
    var set = isPreorder ? state.badgeTexts.preorder : state.badgeTexts.stock;

    /* Pas de texte principal pour cet état → on masque le badge */
    if (!set.main) {
      if (badge) badge.style.display = 'none';
      return;
    }

    /* Si le badge n'existe pas dans le DOM (état initial sans texte), on ne peut
       pas le recréer proprement ici → définir un texte ligne 1 pour les 2 états. */
    if (!badge) return;

    badge.style.display = '';
    var mainEl = badge.querySelector('.napoon-badge__main');
    var subEl  = badge.querySelector('.napoon-badge__sub');
    if (mainEl) mainEl.textContent = set.main;

    /* Ligne 2 : affichée/masquée selon présence de texte */
    if (subEl) {
      if (set.sub) { subEl.textContent = set.sub; subEl.style.display = ''; }
      else { subEl.style.display = 'none'; }
    }
  }

  /* ════════════════════════════════════════════════════════
     VARIANT CHANGE HANDLER
     ════════════════════════════════════════════════════════ */

  function handleVariantSwitch(galleryEl, newVariantId) {
    var state = galleries.get(galleryEl);
    if (!state) return;
    newVariantId = String(newVariantId || '');
    if (newVariantId === state.currentVariantId) return;
    state.currentVariantId = newVariantId;
    var groupId = state.variantMap[newVariantId] || 'default';
    switchGroup(galleryEl, groupId);
    updateBadge(galleryEl, newVariantId); /* ← maj du badge prévente/stock */
  }

  /* ════════════════════════════════════════════════════════
     DIRECT SWATCH INTERCEPTION — input event, CAPTURE phase
     ════════════════════════════════════════════════════════ */

  function setupDirectSwatchListener(galleryEl) {
    var variantsEl = galleryEl.querySelector('[data-napoon-product-variants]');
    if (!variantsEl) return;
    var productVariants;
    try { productVariants = JSON.parse(variantsEl.textContent); }
    catch(e) { return; }

    var variantLookup = {};
    productVariants.forEach(function(v) {
      variantLookup[v.options.join(' / ')] = v;
    });

    document.addEventListener('input', function(e) {
      if (e.target.type !== 'radio') return;
      var vs = e.target.closest('variant-selects');
      if (!vs) return;

      var selectedOptions = [];
      var changedIdx = -1;
      var fieldsets = vs.querySelectorAll('fieldset');

      for (var k = 0; k < fieldsets.length; k++) {
        var checked = fieldsets[k].querySelector('input[type="radio"]:checked');
        if (checked) {
          selectedOptions.push(checked.value);
          if (checked === e.target) changedIdx = k;
        } else {
          var sel = fieldsets[k].querySelector('select');
          if (sel) selectedOptions.push(sel.value);
        }
      }

      var matched = variantLookup[selectedOptions.join(' / ')] || null;

      if (!matched && changedIdx >= 0) {
        var val = e.target.value;
        for (var i = 0; i < productVariants.length; i++) {
          if (productVariants[i].options[changedIdx] === val) {
            matched = productVariants[i];
            break;
          }
        }
      }

      if (matched) handleVariantSwitch(galleryEl, matched.id);
    }, true); /* true = CAPTURE phase */
  }

  /* ════════════════════════════════════════════════════════
     VARIANT CHANGE LISTENER (PubSub + MutationObserver fallback)
     ════════════════════════════════════════════════════════ */

  function setupVariantChangeListener(galleryEl) {
    function tryPubSub() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
          var vid = event.data && event.data.variant ? event.data.variant.id : '';
          handleVariantSwitch(galleryEl, vid);
        });
        return true;
      }
      return false;
    }
    if (!tryPubSub()) {
      var attempts = 0;
      var ri = setInterval(function() {
        if (tryPubSub() || ++attempts > 20) clearInterval(ri);
      }, 200);
    }

    var sectionId = galleryEl.dataset.sectionId;
    var formSel = sectionId
      ? '#product-form-' + sectionId + ' input[name="id"]'
      : 'form[action*="/cart/add"] input[name="id"]';

    (function watch() {
      var inp = document.querySelector(formSel);
      if (!inp) { setTimeout(watch, 300); return; }
      new MutationObserver(function() {
        if (inp.value) handleVariantSwitch(galleryEl, inp.value);
      }).observe(inp, { attributes: true, attributeFilter: ['value'] });
      inp.addEventListener('change', function() {
        if (inp.value) handleVariantSwitch(galleryEl, inp.value);
      });
      var last = inp.value;
      setInterval(function() {
        if (inp.value && inp.value !== last) { last = inp.value; handleVariantSwitch(galleryEl, inp.value); }
      }, 400);
    })();
  }

  /* ════════════════════════════════════════════════════════
     RESIZE
     ════════════════════════════════════════════════════════ */

  var resizeTimeout;
  function setupResizeHandler(galleryEl) {
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        var state = galleries.get(galleryEl);
        state.isDesktop = window.innerWidth >= DESKTOP_BP;
        syncThSize(galleryEl);
        syncThMSize(galleryEl);
      }, 80);
    });
  }

  /* ════════════════════════════════════════════════════════
     INITIALIZE
     ════════════════════════════════════════════════════════ */

  function initializeGalleries() {
    document.querySelectorAll('.napoon-gallery').forEach(function(galleryEl) {
      initGallery(galleryEl);
      setupSwipe(galleryEl);
      setupDirectSwatchListener(galleryEl);
      setupVariantChangeListener(galleryEl);
      setupResizeHandler(galleryEl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeGalleries);
  } else {
    initializeGalleries();
  }
})();